exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-3aada95e]{width:1.2307692308em;height:1.2307692308em;background-color:#ff5714;border-radius:50%}.icon__char[data-v-3aada95e]{color:#fff}", ""]);

// exports
